import { render } from "./Director's_Message.vue?vue&type=template&id=4c7b842a"
import script from "./Director's_Message.vue?vue&type=script&lang=js"
export * from "./Director's_Message.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__